import { render, staticRenderFns } from "./screenFooter.vue?vue&type=template&id=32688f8e&scoped=true&"
import script from "./screenFooter.vue?vue&type=script&lang=js&"
export * from "./screenFooter.vue?vue&type=script&lang=js&"
import style0 from "./screenFooter.vue?vue&type=style&index=0&id=32688f8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32688f8e",
  null
  
)

export default component.exports